import { apiClient } from '@/services/ApiClient.js'

export default {
  getUsers(query) {
    return apiClient
      .get('users', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInsideSalesUsers(query) {
    return apiClient
      .get('users/inside-sales', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getAllocationDepartmentUsers(query) {
    return apiClient
      .get('users/allocation-department', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplicationAssignableUsers() {
    return apiClient
      .get('users/application-assignable')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUser(id) {
    return apiClient
      .get('users/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateUser(id, payload) {
    return apiClient
      .patch('users/' + id, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updatePassword(user) {
    return apiClient
      .patch('users/' + user.id + '/update-password', user)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  prepare2FA(id, mfaOption) {
    return apiClient
      .post('users/' + id + '/prepare-2fa', {
        mfa_option: mfaOption
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  disable2FA(id) {
    return apiClient
      .post('users/' + id + '/disable-2fa')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  confirm2FA(id, code, mfaOption) {
    return apiClient
      .post('users/' + id + '/confirm-2fa', {
        '2fa_code': code,
        mfa_option: mfaOption
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  get2FARecoveryCodes(id) {
    return apiClient
      .get('users/' + id + '/2fa-recovery-codes')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createUser(user) {
    return apiClient
      .post('users', user)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  giveAdminPrivileges(id) {
    return apiClient
      .patch('users/' + id + '/give-admin-privileges')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  revokeAdminPrivileges(id) {
    return apiClient
      .patch('users/' + id + '/revoke-admin-privileges')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getNotifications(id) {
    return apiClient
      .get('users/' + id + '/notifications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsReadNotifications(id) {
    return apiClient
      .patch('users/' + id + '/notifications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsReadNotification(userId, id) {
    return apiClient
      .patch('users/' + userId + '/notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsSeenNotifications(userId) {
    return apiClient
      .patch('users/' + userId + '/notifications/seen')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRoles(id, query = {}) {
    return apiClient
      .get('users/' + id + '/roles', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  attachRole(id, roleId) {
    return apiClient
      .patch('users/' + id + '/roles/' + roleId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  detachRole(id, roleId) {
    return apiClient
      .delete('users/' + id + '/roles/' + roleId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteUser(id) {
    return apiClient
      .delete('users/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
